import Chip from '@mui/material/Chip';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import Switch from '@mui/material/Switch';
import React from 'react';
import { useTheme } from 'styled-components';
import type { EvnexPalette, InputComponentProps, ValueComponentProps } from '../../design-system';
import { toChangeEvent } from '../../utils/formUtils';

export type SwitchValueProps = ValueComponentProps<boolean> & { labels?: { true: string; false: string } };

export const SwitchValue: React.FC<SwitchValueProps> = ({ value, labels = { true: 'On', false: 'Off' } }) => {
  const { palette } = useTheme();
  const { enabled }: EvnexPalette = palette;

  if (value === undefined) {
    return null;
  }

  return value ? (
    <Chip label={labels.true} role="status" size="small" style={{ backgroundColor: enabled.main }} />
  ) : (
    <Chip color="default" label={labels.false} role="status" size="small" />
  );
};

export const SwitchInput: React.FC<InputComponentProps<boolean>> = ({
  disabled,
  error,
  helperText,
  name,
  onBlur,
  onChange,
  value,
}) => (
  <FormControl>
    <Switch
      id={name}
      color="primary"
      checked={value}
      disabled={disabled}
      onBlur={onBlur}
      onChange={(event, checked) => onChange(name)(toChangeEvent(event, checked))}
    />
    {helperText && (
      <FormHelperText variant="outlined" error={error}>
        {helperText}
      </FormHelperText>
    )}
  </FormControl>
);
